import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { calculateBreakPay } from "@src/appV2/redesign/utils/calculateShiftPay";
import { type ExtraWorkedTimeRequestsResponse } from "@src/appV2/Shifts/MandatoryBreakPolicy/api/useExtraWorkedTimeRequests";
import { type ShiftPeriod } from "@src/appV2/Shifts/Shift/types";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { addBusinessDays, differenceInMinutes, format, parseISO } from "date-fns";

import { BreakPaymentRequestCard } from "./Card";

interface BreakPaymentRequestListProps {
  extraWorkedTimeRequestsData: ExtraWorkedTimeRequestsResponse;
}

export function BreakPaymentRequestList({
  extraWorkedTimeRequestsData,
}: BreakPaymentRequestListProps) {
  const pendingBreakPaymentRequests = extraWorkedTimeRequestsData?.data ?? [];

  return (
    <Stack spacing={6}>
      {pendingBreakPaymentRequests.map((request) => {
        const shift = extraWorkedTimeRequestsData?.included.find(
          (included) => included.type === "shift" && included.id === request.attributes.shiftId
        );

        if (!isDefined(shift) || shift.type !== "shift") {
          return null;
        }

        const breakTimeInMinutes = differenceInMinutes(
          parseISO(request.attributes.end),
          parseISO(request.attributes.start)
        );

        const { formattedPayAmount: breakPay } = calculateBreakPay({
          hourlyRate: shift.attributes.pay,
          breakTimeInHours: breakTimeInMinutes / 60,
        });

        return (
          <BreakPaymentRequestCard
            key={request.id}
            shiftTimeSlot={shift.attributes.name as ShiftPeriod}
            shiftStart={shift.attributes.start}
            shiftEnd={shift.attributes.end}
            shiftAgentReq={shift.attributes.agentReq}
            workplaceName={shift.attributes.facility.name}
            breakTimeInMinutes={breakTimeInMinutes}
            breakPay={breakPay}
            approvalDate={format(
              addBusinessDays(parseISO(shift.attributes.end), 3),
              "MMM d, yyyy 'at' h:mm a"
            )}
          />
        );
      })}
    </Stack>
  );
}
